module.exports = __webpack_public_path__ + "index.html?b5ade7fb017c762156662b19fa3f17fe";


//////////////////
// WEBPACK FOOTER
// ./client/static/index.html
// module id = 275
// module chunks = 0